module.exports = __webpack_public_path__ + "img/bc-ozkaynaklar.1ecf7240.png";